import React, { useState, useEffect } from "react";
// import Box from "@mui/material/Box";
// import List from "@mui/material/List";
// import ListItem from "@mui/material/ListItem";
// import Divider from "@mui/material/Divider";
// import { Link } from "react-router-dom";
// import Paper from "@mui/material/Paper";
import Modal from "@mui/material/Modal";
//import Fade from "@mui/material/Fade";
//import Backdrop from "@mui/material/Backdrop";
import Dialog from "@mui/material/Dialog";
import BackDrop from "@mui/material/Backdrop";
import { Constants } from "../../../config/Constants";
//import AddTopic from "./AddTopic";
import { API } from "aws-amplify";
import config from "../../../config/aws-exports";
import CircularProgress from "@mui/material/CircularProgress";
//import image from "./2.png";
// import { useSelector, useDispatch } from "react-redux";
// import {  authData } from "../../../redux/auth/authSlice";
// import { useNavigate } from "react-router-dom";
import EditTopic from "./EditTopic";
import DeleteTopic from "./DeleteTopic";
import { ReactComponent as Edit } from "../../../assets/icons/mode_black_24dp.svg";
import { ReactComponent as Delete } from "../../../assets/icons/delete_outline_black_24dp.svg";
import contentStyle from "./content.module.scss";
import NothiongHereYet from "../../../assets/Nothing Here Yet.gif";
import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";
import { CSVLink } from "react-csv";
import { FileDownload } from "@mui/icons-material";
import { Button } from "semantic-ui-react";
//import { Box } from "@mui/material";


// Styles for material components
export default function Elearning() {
  // let userDetails = useSelector(authData);
  // const dispatch = useDispatch();
  // const classes = useStyles();
  // const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [catdata, setCatdata] = useState([]);
  // const [openAddTopic, setOpenAddTopic] = useState(false);
  const [editopen, setEditOpen] = useState(false);
  const [dataToEdit, setDataToEdit] = useState({});
  const [deleteopen, setDeleteOpen] = useState(false);
  const [dataToDelete, setDataToDelete] = useState({});
  // const handleAddTopicOpen = () => setOpenAddTopic(true);
  // const handleAddTopicClose = () => setOpenAddTopic(false);
  useEffect(() => {
    getTopicList();

    return () => { };
  }, []);
  async function getTopicList() {
    setLoading(true);
    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        schema: Constants.SCHEMA_NAME,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      console.log(bodyParam.body);
      const list = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.GET_CATEGORIES,
        bodyParam
      );
      console.log(JSON.stringify(list));
      setCatdata(list.topics);

      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  }
  function handleEditOpen(item) {
    setEditOpen(true);
    setDataToEdit(item);
  }
  const handleEditClose = () => {
    setEditOpen(false);
  };
  function handleDeleteOpen(item) {
    setDeleteOpen(true);
    setDataToDelete(item);
  }
  const handleDeleteClose = () => {
    setDeleteOpen(false);
  };
  // const gotocontent = (item) => {
  //   let sdata = { ...userDetails };
  //   sdata.categorydata = item;
  //   if (sdata.breadcrumb == undefined) {
  //     sdata.breadcrumb = [];
  //     let temp = [...sdata.breadcrumb];
  //     temp[0] = {
  //       name: "Topic",
  //       path: "/category",
  //     };
  //     temp[1] = {
  //       name: item.name,
  //       path: "/category/content",
  //     };
  //     sdata.breadcrumb = temp;
  //   } else {
  //     let temp = [...sdata.breadcrumb];
  //     temp[0] = {
  //       name: "Topic",
  //       path: "/category",
  //     };
  //     temp[1] = {
  //       name: item.name,
  //       path: "/category/content",
  //     };
  //     sdata.breadcrumb = temp;
  //   }
  //   dispatch(awsSignIn(sdata));
  //   navigate("/category/content");
  // };

  const tcolumns = [
    {
      field: "ct_img",
      headerName: "Image",
      headerClassName: `${contentStyle.headerCell}`,
      flex: 1,
      minWidth: 180,
      disableExport: true,
      renderCell: (params) => (
        <img
          style={{
            width: "130px",
            height: "80px",
            borderRadius: "10px",
            marginTop: "10px"
          }}
          src={`https://${config.DOMAIN
            }/${config.aws_org_id.toLowerCase()}-resources/images/category-images/${params.value
            }`}
          alt=""
        ></img>
      ),
    },
    {
      field: "name",
      headerName: "Subject Name",
      flex: 2,
      minWidth: 250,
      headerClassName: `${contentStyle.headerCell}`,
    },
    {
      field: "name1",
      headerName: "Edit/Delete",
      flex: 1,
      minWidth: 250,
      headerClassName: `${contentStyle.headerCell}`,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
            flexDirection: "column",
            marginTop: "25px",
          }}
        >
          <Edit
            sx={{ m: 3 }}
            className={contentStyle.icons}
            onClick={() => handleEditOpen(params?.row)}
          />
          <Delete
            sx={{ m: 3 }}
            className={contentStyle.icons}
            onClick={() => handleDeleteOpen(params?.row)}
          />
        </div>
      ),
    },
  ];
  function CustomToolbar() {
    const headers = [{ label: "Subject Name", key: "name" }];

    return (
      <GridToolbarContainer
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <Button color="primary">
          <CSVLink
            data={catdata}
            headers={headers}
            filename="subject-details"
            className={contentStyle.exp_btn}
          >
            <FileDownload />
            Export
          </CSVLink>
        </Button>
      </GridToolbarContainer>
    );
  }
  return (
    <div className={contentStyle.main}>
      <Dialog
        // fullScreen={fullScreen}
        open={deleteopen}
        aria-labelledby="responsive-dialog-title-2"
        maxWidth="md"
      >
        <DeleteTopic
          handledeleteSpeakersClose={handleDeleteClose}
          dataToDelete={dataToDelete}
          setpeakerTable={getTopicList}
        />
      </Dialog>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={contentStyle.modal}
        open={editopen}
        //closeAfterTransition
        //BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        {/* <Fade in={editopen}>
           <Box sx={{ p: 2 }}> */}
        <EditTopic
          handleEditClose={handleEditClose}
          dataToEdit={dataToEdit}
          getPrograms={getTopicList}
        />
        {/* </Box>
        </Fade> */}
      </Modal>

      {!loading && catdata !== undefined && catdata.length > 0 ? (
        <div
          style={{ height: 450, width: "100%", overflow: "auto" }}
          className={contentStyle.root}
        >
          <DataGrid
            rows={catdata}
            columns={tcolumns}
            rowHeight={100}
            className={contentStyle.headerGrid}
            slots={{
              toolbar: CustomToolbar,
            }}
            disableSelectionOnClick
          />
        </div>
      ) : // <Box
        //   sx={{
        //     display: "flex",

        //     "& > :not(style)": {
        //       m: 1,
        //       width: 1,
        //       height: "100%",
        //     },
        //   }}
        // >
        //   <Paper elevation={3}>
        //     <List>
        //       {catdata?.map((item) => (
        //         <ListItem
        //           key={item.name}
        //           sx={{ display: "flex", alignItems: "center" }}
        //         >
        //           <img
        //             style={{
        //               width: "200px",
        //               height: "100px",
        //               borderRadius: "10px",
        //             }}
        //             src={`https://${config.DOMAIN
        //               }/${config.aws_org_id.toLowerCase()}-resources/images/category-images/${item.ct_img
        //               }`}
        //             alt=""
        //           ></img>
        //           <Link
        //             style={{ padding: "10px", color: "black", fontSize: "18px", textDecoration: "none" }}
        //             to="#"
        //             onClick={() => gotocontent(item)}
        //           >
        //             <h5> {item.name} </h5>
        //           </Link>
        //           <Box sx={{ flexGrow: 1 }} />
        //           <Edit
        //             sx={{ m: 3 }}
        //             className={contentStyle.icons}
        //             onClick={() => handleEditOpen(item)}
        //           />
        //         </ListItem>
        //       ))}

        //       <Divider />
        //     </List>
        //   </Paper>

        // </Box>
        catdata !== undefined && catdata.length === 0 ? (
          <div
            style={{
              height: "50vh",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              // marginBottom:'400px'
            }}
          >
            <img src={NothiongHereYet} alt="Nothing Here" />
          </div>
        ) : null}

      <BackDrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        className={contentStyle.backdrop}
      >
        <CircularProgress color="inherit" />
      </BackDrop>
    </div>
  );
}
